/**
 * The study's forms by id and title, as `GET study/:id/form/titles` sends them to a Manage users
 * holder: every form the study has, its own and shared ones, with no definition (ENG-10136). The
 * People tab's By-form lens and a grant's form lists read it when the caller lacks Manage forms,
 * since `GET study/:id/forms` then sends only the forms they may view (users decision 23).
 *
 * The wire types match spdata-api's `StudyFormTitle` in `src/study/people/study.form.titles.service.ts`.
 */

/** One row of `GET study/:id/form/titles`. */
export interface NetworkStudyFormTitle {
  /** Hex, as the picker and the Team page's URL name a form. */
  id: string;
  /** Base64, as a grant's `viewForms` and `addEntryForms` list it. */
  base64Id: string;
  title: string | null;
  /** Whether another study owns the form and this one reads it. */
  sharedForm: boolean;
}

export interface NetworkStudyFormTitles {
  forms: NetworkStudyFormTitle[];
}

/** One form by name, keyed the way `FormModel` keys it so a picker reads either list alike. */
export interface StudyFormTitle {
  /** Hex. */
  identifier: string;
  base64Id: string;
  /** Empty for a form with no title, as the forms list leaves it. */
  title: string;
}

export const studyFormTitleFromBackend = (form: NetworkStudyFormTitle): StudyFormTitle => ({
  identifier: form.id,
  base64Id: form.base64Id,
  title: form.title ?? ''
});
